export default __webpack_public_path__ + "static/media/minus-symbol.1df3bead.svg";